import { useState, useCallback } from 'react';
import { pw9224Api, F924 } from '../../../services/pw9224Api';

export function useLookupNames() {
  const [names, setNames] = useState<Record<string, string>>({});

  const resolveAllNames = useCallback(async (data: Partial<F924>) => {
    const entries: [string, string, string][] = [
      ['employee', 'employee', data.f924_11 || ''],
      ['agent', 'employee', data.f924_13 || ''],
      ['entryPerson', 'employee', data.f924_91 || ''],
      ['reviewer', 'employee', data.f924_72 || ''],
      ['initApprover', 'employee', data.f924_81 || ''],
      ['reApprover', 'employee', data.f924_84 || ''],
    ];
    const results = await Promise.all(
      entries.map(([key, type, code]) =>
        pw9224Api.lookupName(type, code).then(name => [key, name] as [string, string])
      )
    );
    setNames(prev => {
      const next = { ...prev };
      for (const [key, name] of results) next[key] = name;
      return next;
    });
  }, []);

  const resolveSingleName = useCallback(async (nameKey: string, type: string, code: string) => {
    const name = await pw9224Api.lookupName(type, code);
    setNames(prev => ({ ...prev, [nameKey]: name }));
  }, []);

  const clearNames = useCallback(() => setNames({}), []);

  return { names, resolveAllNames, resolveSingleName, clearNames };
}
